import { Injectable, inject } from '@angular/core';
import { HttpService, ApiResponse, AuthContent } from '@nebula-shared/data-access';
import { AuthService, resolveEnvKey, resetVaultAccountBlockedCircuit } from '@nebula/shared-vault/data-access';
import { catchError, map, Observable, tap, throwError } from 'rxjs';
import { LoginPayload } from '../../../domain/src/lib/login.model';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { ERROR_LOGIN_MESSAGES } from '../../../const/src/lib/login.constant';

@Injectable({ providedIn: 'root' })
export class LoginService {
  private readonly http = inject(HttpService);
  private readonly authService = inject(AuthService);

  public login(payload: LoginPayload): Observable<AuthContent> {
    resetVaultAccountBlockedCircuit();
    this.authService.forceClearSession();

    const loginPayload = {
      username: payload.user.trim(),
      password: payload.password.trim(),
    };

    const headers = new HttpHeaders({
      'x-simappe-environment': resolveEnvKey(),
    });

    return this.http
      .post<AuthContent>(`/simappe-oauth2-server/api/v1/login`, loginPayload, undefined, headers)
      .pipe(
        map((response: ApiResponse<AuthContent>) => response.response.content),
        tap((content) => this.authService.handleSuccessfulAuth(content)),
        catchError((error: HttpErrorResponse) => {
          let errorMessage = 'Error en la autenticación';

          if (error.error?.response?.content) {
            errorMessage = error.error.response.content;
          } else if (error.status === 401) {
            if (error.error?.error === 'Unauthorized') {
              errorMessage = ERROR_LOGIN_MESSAGES.ERROR.UNAUTHORIZED.TITLE;
            } else {
              errorMessage = ERROR_LOGIN_MESSAGES.ERROR.UNAUTHORIZED.SUBTITLE;
            }
          } else if (error.status === 0) {
            errorMessage = ERROR_LOGIN_MESSAGES.ERROR.GENERIC.TITLE;
          }

          return throwError(() => errorMessage);
        }),
      );
  }
}
